import { Api } from '@/src/store'

export const cardAccountQueryArgs = {
  query: { limit: 1 },
} as const satisfies (typeof Api.endpoints)['GET /card/accounts']['Types']['QueryArg']

/**
 * the implementation of this should probably change in the future if the hook itself doesn't become totally irrelevant due to introducing support for multiple card accounts.
 * for now though, this is good enough because we _do_ assume a user can have at most one card account
 */
export function useCardAccount() {
  return Api.endpoints['GET /card/accounts'].useQuery(cardAccountQueryArgs, {
    refetchOnMountOrArgChange: true,
  })
}
